export default __webpack_public_path__ + "static/media/medium.6f8601e7.svg";